
import React, { useState, useEffect } from "react";
import { changePasswordApiCall } from "../../actions/Profile";
import { connect } from "react-redux";
import { compose } from "redux";
import Paper from "@material-ui/core/Paper";

import { makeStyles } from "@material-ui/core/styles";
import { useOktaAuth } from '@okta/okta-react';


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3, 2)
  }
}));

const Profile = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const [userInfo, setUserInfo] = useState(null);
  const styles = useStyles;

  useEffect(() => {
    if (!authState?.isAuthenticated) {
      setUserInfo(null);
    } else {
      getUserData();
    }
  }, [authState, oktaAuth]);

  async function getUserData() {

    await oktaAuth.getUser().then((user) => {
      setUserInfo(user);
    });
  }

  return (
    <div>
      {userInfo &&
        <section className="user-profile" data-sub={userInfo.sub}>
          <h3>
            Profile Information
          </h3>
          <Paper className={styles.root}>
            <div>
              <label>
                Name:
              </label>
              <span>{userInfo.name}</span>
            </div>
            <div>
              <label>
                User Name:
              </label>
              <span>{userInfo.preferred_username}</span>
            </div>
          </Paper>
          <div>&nbsp;</div>
        </section>
      }
    </div>
  );

};

const stateToProps = state => {
  return { error: state.profile.error, success: state.profile.success };
};

const dispatchToProps = dispatch => {
  return {
    changePasswordApiCall: data => dispatch(changePasswordApiCall(data))
  };
};

export default compose(connect(stateToProps, dispatchToProps))(Profile);
